import PropTypes from 'prop-types';
import React from 'react';
import styles from './SearchBar-style.scss';

export const SearchBarSection = ({ title, children }) => {
    return (
        <div data-tn="search-bar-section" className={styles.section}>
            <div data-tn="search-bar-header" className={styles.header}>
                {title}
            </div>
            {children}
        </div>
    );
};

SearchBarSection.propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
};
